import React, {useContext, useEffect, useState} from 'react'
import {withRouter, useParams} from 'react-router-dom'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import {MenuCs} from '../../config/page_route'
import PageSubHeader from '../../components/common/page_sub_header'
import ConfirmButton from '../../components/control/button/confirm_button'
import {API_URL} from '../../config/const'
import {Page_settings} from "../../config/page_settings";
import {rootStore} from '../../mobx/store'

const NoticeDetail = observer((props) => {
  const context = useContext(Page_settings)
  const { id } = useParams();
  const [info, setInfo] = useState({})
  const [show, setShow] = useState(false);
  const category = [strings.notice, strings.event, strings.event_result]
  const active = 0

  const getNotice = (no_id) => {
    context.post( 'cs/notice_detail', {no_id: no_id},
      response => {
        setInfo(response.detail);
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  useEffect(() => {
    context.getPoint()
  }, [])

  useEffect(() => {
    getNotice(id);
  }, [id])

  const onDownLoad = () => {
    window.location.href=API_URL+'/api/upload/download?folder=notice&filename='+info.no_file
  }

  function isImageFile(fileName) {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.svg', '.webp'];
    const fileExtension = fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
    
    return imageExtensions.includes(`.${fileExtension}`);
}


  return (
    <React.Fragment>
      <div className='content-container'>
        {info.no_cate == 1 && <SidebarLeft menu={MenuCs} active={active} history={props.history} />}
        {info.no_cate > 1 && <SidebarLeft history={props.history} />}
        <div className='im-container sm-pb-100'>
          <PageSubHeader pageName={info.no_cate == 1 ? strings.notice : strings.event} pageMenu1={strings.main} pageMenu2={info.no_cate == 1 ? strings.cs_center : ''} pageMenu={info.no_cate == 1 ? strings.notice : strings.event}/>
          <div className='mt-30 sm-mt-20 fs-24 sm-fs-18 f-b'>{info.no_title}</div>
          <div className='mt-10 divider2'/>
          <div className='notice-basic-info pt-20 mt-30 sm-mt-20 mh-20 sm-mh-15'>
            <div className='fs-20 sm-fs-18 f-b ph-20'>{category[info.no_cate - 1]}</div>
            <div className='mt-10 divider m-0'/>
            <div className='d-flex ph-20 pv-10'>
              <div className='fs-16 sm-fs-14 f-m color-555555'>{info.mb_nick ? info.mb_nick : strings.admin}</div><span className='mh-10'>|</span><div className='fs-16 sm-fs-14 f-m color-555555'>{info.no_createdat?.dateFormat('YYYY.MM.DD')}</div>
            </div>
          </div>
          <div className='mt-30 sm-mt-20 fs-16 sm-fs-14 ph-40 space-break'>
            {info.no_note}
            {info.no_file  &&  isImageFile(info.no_file) && <img className={'w-100'} src={API_URL+'/api/upload/download?folder=notice&filename='+info.no_file}></img>}
          </div>
          {info.no_file  && isImageFile(info.no_file) && 
          <div className='d-flex mt-60 ph-40' onClick={() => {onDownLoad()}}>
            <img src={'/assets/image/file.png'} width={20} height={20}/>
            <a className='fs-16 sm-fs-14 text-underline mh-10'>{info.no_file}</a>
          </div>
          }
          <div className='mt-30 sm-mt-20 divider2'/>
          <ConfirmButton enabled={true} className={'btn-save fs-15 sm-fs-14 f-sb'} onClick={() => {props.history.goBack()}} text={strings.list} />
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(NoticeDetail)